module.exports = __webpack_public_path__ + "img/java.a065e9b6.png";